import React, { useState, useContext } from "react";
import { ThemeContext } from "../context/ThemeContext";
import getCurrentSkin from "../utils/getCurrentSkin";
import HeaderBar from "../components/HeaderBar";
import ProjectPostOrderLayoutWrapper from "../components/ProjectPostOrderLayoutWrapper";
import ProjectPerOrderLayoutWrapper from "../components/ProjectPreOrderLayoutWrapper";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { 
  FaSearch, 
  FaFilter, 
  FaFileAlt, 
  FaChevronUp, 
  FaChevronDown,
  FaDownload,
  FaPrint,
  FaEye,
  FaCalendarAlt
} from "react-icons/fa";

const EstimationWaitingReport =  ({ type }) => {
  const { isDark, skin, setSkin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const { baseColor, baseShade } = currentSkin;
  const buttonClass = `bg-${baseColor}-${baseShade}`;
  const hoverClass = `hover:bg-${baseColor}-700`;

  // State to toggle filter form visibility
  const [showFilters, setShowFilters] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
 const LayoutWrapper =
    type === "preorder"
      ? ProjectPerOrderLayoutWrapper
      : ProjectPostOrderLayoutWrapper;

      
  // Filter state
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    projectName: "",
    estimationCode: "",
    minAmount: "",
    maxAmount: ""
  });

  // Sample data for the estimation waiting report
  const estimationData = [
    { sno: 1, estimationCode: "EST/26", projectName: "aSa", estimationCost: "1200.00" },
    { sno: 2, estimationCode: "EST/33", projectName: "building work in rs puram", estimationCost: "2400330.00" },
    { sno: 3, estimationCode: "EST/12", projectName: "Construction of Store in Physics department", estimationCost: "227010.00" },
    { sno: 4, estimationCode: "EST/4", projectName: "GANDHIPURAM BRIDGE WORK", estimationCost: "14530800.00" },
    { sno: 5, estimationCode: "EST/37", projectName: "Gandhipuram Building Work 6", estimationCost: "8700.00" },
    { sno: 6, estimationCode: "EST/2059", projectName: "hfgh", estimationCost: "5000.00" },
    { sno: 7, estimationCode: "EST/7", projectName: "karamadai bridge work", estimationCost: "441190.00" },
    { sno: 8, estimationCode: "EST/10", projectName: "KARAMADAI Rail Bridge", estimationCost: "1047880.00" },
    { sno: 9, estimationCode: "EST/15", projectName: "Mangalore well work", estimationCost: "3797500.00" },
    { sno: 10, estimationCode: "EST/19", projectName: "NORTH COIMBATORE BRIDGE CONSTRUCTION", estimationCost: "99136000.00" },
    { sno: 11, estimationCode: "EST/38", projectName: "Plant 1", estimationCost: "3488550.00" },
    { sno: 12, estimationCode: "EST/16", projectName: "road work in rs puram", estimationCost: "44000.00" },
    { sno: 13, estimationCode: "EST/18", projectName: "RS PURAM BRIDGE WORK", estimationCost: "35544400.00" },
    { sno: 14, estimationCode: "EST/8", projectName: "RS PURAM BUILDING CONSTRUCTION WORK", estimationCost: "17585000.00" },
    { sno: 15, estimationCode: "EST/6", projectName: "RS PURAM BUILDING WORK", estimationCost: "807000.00" },
    { sno: 16, estimationCode: "EST/27", projectName: "RS Puram Water Tank Construction", estimationCost: "3275400.00" },
    { sno: 17, estimationCode: "EST/36", projectName: "SRM", estimationCost: "39500.00" },
    { sno: 18, estimationCode: "EST/35", projectName: "Stanford university lab work", estimationCost: "30000.00" },
    { sno: 19, estimationCode: "EST/17", projectName: "temple work in mangalore", estimationCost: "19500.00" },
    { sno: 20, estimationCode: "EST/20", projectName: "TEST Project", estimationCost: "508800.00" },
    { sno: 21, estimationCode: "EST/32", projectName: "test project 4545", estimationCost: "4004000.00" },
    { sno: 22, estimationCode: "EST/30", projectName: "TEST Project23", estimationCost: "600000.00" },
    { sno: 23, estimationCode: "EST/28", projectName: "UNIT I RS PURAM Water Tank Construction", estimationCost: "4617100.00" }
  ];

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSearch = () => {
    toast.success("Search filters applied!");
  };

  const handleExport = () => {
    toast.success("Report exported successfully!");
  };

  const handlePrint = () => {
    toast.success("Report sent to printer!");
  };

  const handleViewDetails = (estimationCode) => {
    toast.info(`Viewing details for ${estimationCode}`);
  };

  // Filter data based on search term
  const filteredData = estimationData.filter(item =>
    item.projectName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.estimationCode.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Calculate total amount
  const totalAmount = filteredData.reduce((sum, item) => sum + parseFloat(item.estimationCost), 0);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  return (
    <LayoutWrapper>
      <div className={`min-h-screen p-6 ${isDark ? "bg-gray-900" : "bg-gray-100"}`}>
        <HeaderBar
          title={<span className="font-dmserif text-3xl">ESTIMATION WAITING REPORT</span>}
          setSkin={setSkin}
          currentSkin={skin}
        />

        <div className={`p-6 mt-6 rounded-2xl shadow-xl border ${
          isDark
            ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
            : "bg-white text-black"
        }`}>
          {/* Header Section */}
          <div className="flex justify-between items-center mb-6">
            <div className="flex items-center gap-4">
              <FaFileAlt className={`text-2xl ${isDark ? "text-blue-400" : "text-blue-600"}`} />
              <h1 className={`text-2xl font-bold ${isDark ? "text-white" : "text-gray-900"}`}>
                Estimation Waiting Report
              </h1>
            </div>

            <div className="flex items-center gap-3">
              {/* Search Bar */}
              <div className="relative">
                <FaSearch className={`absolute left-3 top-1/2 transform -translate-y-1/2 ${
                  isDark ? "text-gray-400" : "text-gray-500"
                }`} />
                <input
                  type="text"
                  placeholder="Search projects..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className={`pl-10 pr-4 py-2 rounded-lg border focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all ${
                    isDark 
                      ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400" 
                      : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                  }`}
                />
              </div>

              {/* Action Buttons */}
              <button
                onClick={handleExport}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 ${
                  isDark
                    ? "bg-green-600 hover:bg-green-700 text-white"
                    : "bg-green-500 hover:bg-green-600 text-white"
                }`}
              >
                <FaDownload />
                Export
              </button>

              <button
                onClick={handlePrint}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 ${
                  isDark
                    ? "bg-purple-600 hover:bg-purple-700 text-white"
                    : "bg-purple-500 hover:bg-purple-600 text-white"
                }`}
              >
                <FaPrint />
                Print
              </button>

              <button
                onClick={() => setShowFilters(!showFilters)}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 ${
                  isDark
                    ? "bg-gray-700 hover:bg-gray-600 text-white border border-gray-600"
                    : "bg-gray-100 hover:bg-gray-200 text-gray-700 border border-gray-300"
                }`}
              >
                {showFilters ? <FaChevronUp /> : <FaChevronDown />}
                {showFilters ? "Hide Filters" : "Show Filters"}
              </button>
            </div>
          </div>

          {/* Filter Section */}
          {showFilters && (
            <div className={`p-6 rounded-lg mb-6 ${
              isDark ? "bg-gray-800/50" : "bg-blue-50"
            }`}>
              <h3 className={`text-lg font-semibold mb-4 flex items-center gap-2 ${
                isDark ? "text-white" : "text-blue-900"
              }`}>
                <FaFilter />
                Filter Options
              </h3>
              
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-4">
                <div>
                  <label className={`block text-sm font-medium mb-2 ${
                    isDark ? "text-gray-300" : "text-gray-700"
                  }`}>
                    From Date
                  </label>
                  <input
                    type="date"
                    value={filters.fromDate}
                    onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all ${
                      isDark 
                        ? "bg-gray-700 border-gray-600 text-white" 
                        : "bg-white border-gray-300 text-gray-900"
                    }`}
                  />
                </div>

                <div>
                  <label className={`block text-sm font-medium mb-2 ${
                    isDark ? "text-gray-300" : "text-gray-700"
                  }`}>
                    To Date
                  </label>
                  <input
                    type="date"
                    value={filters.toDate}
                    onChange={(e) => handleFilterChange('toDate', e.target.value)}
                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all ${
                      isDark 
                        ? "bg-gray-700 border-gray-600 text-white" 
                        : "bg-white border-gray-300 text-gray-900"
                    }`}
                  />
                </div>

                <div>
                  <label className={`block text-sm font-medium mb-2 ${
                    isDark ? "text-gray-300" : "text-gray-700"
                  }`}>
                    Project Name
                  </label>
                  <input
                    type="text"
                    placeholder="Enter project name"
                    value={filters.projectName}
                    onChange={(e) => handleFilterChange('projectName', e.target.value)}
                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all ${
                      isDark 
                        ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400" 
                        : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                    }`}
                  />
                </div>

                <div>
                  <label className={`block text-sm font-medium mb-2 ${
                    isDark ? "text-gray-300" : "text-gray-700"
                  }`}>
                    Estimation Code
                  </label>
                  <input
                    type="text"
                    placeholder="EST/..."
                    value={filters.estimationCode}
                    onChange={(e) => handleFilterChange('estimationCode', e.target.value)}
                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all ${
                      isDark 
                        ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400" 
                        : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                    }`}
                  />
                </div>

                <div>
                  <label className={`block text-sm font-medium mb-2 ${
                    isDark ? "text-gray-300" : "text-gray-700"
                  }`}>
                    Min Amount
                  </label>
                  <input
                    type="number"
                    placeholder="0.00"
                    value={filters.minAmount}
                    onChange={(e) => handleFilterChange('minAmount', e.target.value)}
                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all ${
                      isDark 
                        ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400" 
                        : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                    }`}
                  />
                </div>

                <div>
                  <label className={`block text-sm font-medium mb-2 ${
                    isDark ? "text-gray-300" : "text-gray-700"
                  }`}>
                    Max Amount
                  </label>
                  <input
                    type="number"
                    placeholder="0.00"
                    value={filters.maxAmount}
                    onChange={(e) => handleFilterChange('maxAmount', e.target.value)}
                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all ${
                      isDark 
                        ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400" 
                        : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                    }`}
                  />
                </div>
              </div>

              <div className="flex justify-center">
                <button
                  onClick={handleSearch}
                  className={`flex items-center gap-2 px-6 py-2 rounded-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 ${
                    isDark ? `${buttonClass} ${hoverClass} text-white` : `${buttonClass} ${hoverClass} text-white`
                  }`}
                >
                  <FaSearch />
                  Apply Filters
                </button>
              </div>
            </div>
          )}

          {/* Summary Statistics */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            <div className={`p-4 rounded-lg border ${
              isDark 
                ? "bg-blue-900/20 border-blue-700" 
                : "bg-blue-50 border-blue-200"
            }`}>
              <div className="text-center">
                <h3 className={`text-lg font-semibold ${
                  isDark ? "text-blue-300" : "text-blue-900"
                }`}>
                  Total Records
                </h3>
                <p className={`text-2xl font-bold ${
                  isDark ? "text-white" : "text-blue-600"
                }`}>
                  {filteredData.length}
                </p>
              </div>
            </div>

            <div className={`p-4 rounded-lg border ${
              isDark 
                ? "bg-green-900/20 border-green-700" 
                : "bg-green-50 border-green-200"
            }`}>
              <div className="text-center">
                <h3 className={`text-lg font-semibold ${
                  isDark ? "text-green-300" : "text-green-900"
                }`}>
                  Total Amount
                </h3>
                <p className={`text-xl font-bold ${
                  isDark ? "text-white" : "text-green-600"
                }`}>
                  ₹{formatCurrency(totalAmount)}
                </p>
              </div>
            </div>

            <div className={`p-4 rounded-lg border ${
              isDark 
                ? "bg-orange-900/20 border-orange-700" 
                : "bg-orange-50 border-orange-200"
            }`}>
              <div className="text-center">
                <h3 className={`text-lg font-semibold ${
                  isDark ? "text-orange-300" : "text-orange-900"
                }`}>
                  Avg Amount
                </h3>
                <p className={`text-xl font-bold ${
                  isDark ? "text-white" : "text-orange-600"
                }`}>
                  ₹{formatCurrency(totalAmount / filteredData.length || 0)}
                </p>
              </div>
            </div>

            <div className={`p-4 rounded-lg border ${
              isDark 
                ? "bg-purple-900/20 border-purple-700" 
                : "bg-purple-50 border-purple-200"
            }`}>
              <div className="text-center">
                <h3 className={`text-lg font-semibold ${
                  isDark ? "text-purple-300" : "text-purple-900"
                }`}>
                  Status
                </h3>
                <p className={`text-xl font-bold ${
                  isDark ? "text-white" : "text-purple-600"
                }`}>
                  Waiting
                </p>
              </div>
            </div>
          </div>

          {/* Data Table */}
          <div className={`rounded-xl shadow-sm border overflow-hidden ${
            isDark ? "border-gray-700" : "border-gray-200"
          }`}>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className={`${buttonClass} text-white`}>
                  <tr>
                    <th className="px-6 py-4 text-center font-semibold border-r border-white/20">
                      S.no
                    </th>
                    <th className="px-6 py-4 text-center font-semibold border-r border-white/20">
                      Estimation Code
                    </th>
                    <th className="px-6 py-4 text-center font-semibold border-r border-white/20">
                      Project Name
                    </th>
                    <th className="px-6 py-4 text-center font-semibold border-r border-white/20">
                      Estimation Cost
                    </th>
                    <th className="px-6 py-4 text-center font-semibold">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className={`divide-y ${
                  isDark ? "divide-gray-700" : "divide-gray-200"
                }`}>
                  {filteredData.map((item) => (
                    <tr key={item.sno} className={`transition-colors duration-200 ${
                      isDark ? "bg-gray-800 hover:bg-gray-750" : "bg-white hover:bg-gray-50"
                    }`}>
                      <td className={`px-6 py-4 text-center border-r ${
                        isDark ? "border-gray-700 text-white" : "border-gray-200 text-gray-900"
                      }`}>
                        {item.sno}
                      </td>
                      <td className={`px-6 py-4 text-center border-r font-medium ${
                        isDark ? "border-gray-700 text-blue-300" : "border-gray-200 text-blue-600"
                      }`}>
                        {item.estimationCode}
                      </td>
                      <td className={`px-6 py-4 text-left border-r ${
                        isDark ? "border-gray-700 text-white" : "border-gray-200 text-gray-900"
                      }`}>
                        <div className="max-w-xs truncate" title={item.projectName}>
                          {item.projectName}
                        </div>
                      </td>
                      <td className={`px-6 py-4 text-right border-r font-semibold ${
                        isDark ? "border-gray-700 text-green-300" : "border-gray-200 text-green-600"
                      }`}>
                        ₹{formatCurrency(parseFloat(item.estimationCost))}
                      </td>
                      <td className="px-6 py-4 text-center">
                        <button
                          onClick={() => handleViewDetails(item.estimationCode)}
                          className={`px-3 py-1 rounded-lg text-xs font-medium transition-all duration-200 hover:scale-105 ${
                            isDark 
                              ? "bg-blue-600 hover:bg-blue-700 text-white" 
                              : "bg-blue-100 hover:bg-blue-200 text-blue-700"
                          }`}
                        >
                          <FaEye className="inline mr-1" />
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot className={`${buttonClass} text-white`}>
                  <tr>
                    <td colSpan="3" className="px-6 py-4 text-center font-bold border-r border-white/20">
                      TOTAL
                    </td>
                    <td className="px-6 py-4 text-right font-bold border-r border-white/20">
                      ₹{formatCurrency(totalAmount)}
                    </td>
                    <td className="px-6 py-4"></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          {/* Results Info */}
          <div className="mt-4 flex justify-between items-center">
            <div className={`text-sm ${isDark ? "text-gray-400" : "text-gray-600"}`}>
              Showing {filteredData.length} of {estimationData.length} records
            </div>
            <div className={`text-sm ${isDark ? "text-gray-400" : "text-gray-600"}`}>
              Last updated: {new Date().toLocaleString()}
            </div>
          </div>

          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            closeOnClick
            pauseOnHover
            theme={isDark ? "dark" : "light"}
          />
        </div>
      </div>
    </LayoutWrapper>
  );
};

export default EstimationWaitingReport;